"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styles = {
  subtitulo: {
    marginBottom: '8px'
  },
  formControl: {
    marginBottom: '20px',
    minWidth: '120px',
    width: '98%'
  },
  horaIngresoYEgreso: {
    marginBottom: '8px',
    minWidth: '120px',
    width: '96%'
  },
  politicas: {
    marginBottom: '10px',
    alignItems: 'flex-start',
    '& .MuiFormControlLabel-label': {
      marginTop: '11px'
    }
  },
  bold: {
    fontWeight: 700
  },
  checkHuecos: {
    margin: '0px 0px 4px 0px',
    "@media screen and (min-width: 550px)": {
      marginLeft: '9%'
    }
  },
  estadiaEntreReservas: {
    "@media screen and (min-width: 550px)": {
      width: '40%',
      margin: '0px 0px 20px 10%'
    },
    marginBottom: '20px'
  },
  "& .MuiSelect-select": {
    background: "red"
  }
};
var _default = styles;
exports.default = _default;